import { useEffect, useState } from "react";
import { SessionTable, TaskList, useFlowTasks } from "./components";
import { useSessionTaskModal } from "./SessionTaskModal";
import { FlowTask } from "@/app/providers/services";
import { SessionModal } from "./SessionModal";
import { RenderForRoles } from "@/auth/RenderForRoles";
import type { QueryParams } from "@imminently/immi-query";
import SplitPane from "@imminently/decisively-ui/SplitPane";
import { MONITOR_SESSIONS_RELEASE_FILTER_KEY } from "@/features/releaseFilter/releaseFilterKeys";
import { useHistory, useLocation } from "react-router-dom";


const FlowTaskList = () => {
  const { data: tasks, query, total, loadMore } = useFlowTasks();
  const openTaskModal = useSessionTaskModal();
  const { isLoading } = query;
  const canLoad = !query.isError && !query.isFetching && (query.hasNextPage ?? false);
  return (
    <TaskList
      tasks={tasks as FlowTask[]}
      total={total}
      isLoading={isLoading}
      canLoad={canLoad}
      loadMore={loadMore}
      onTaskClick={openTaskModal}
      style={{ flex: 1 }}
    />
  );
};

export type SessionsProps = {
  /** Optional filter for the session list (e.g. hasFailedInteraction: true). Merged with model/release in SessionTable. */
  filter?: QueryParams;
  activeSessionId?: string;
  /** When true, table shows failed-interactions columns and Refire All Failed. */
  showFailedState?: boolean;
};

export const Sessions = ({ filter, activeSessionId, showFailedState = false }: SessionsProps) => {
  const history = useHistory();
  const location = useLocation();
  const [selectedSession, setSelectedSession] = useState<{ id: string; version?: string; release?: string } | null>(null);
  const modalSession = selectedSession ?? (activeSessionId ? { id: activeSessionId } : null);

  useEffect(() => {
    if (activeSessionId && selectedSession && selectedSession.id !== activeSessionId) {
      setSelectedSession(null);
    }
  }, [activeSessionId, selectedSession]);

  const openSessionModal = (session: any) => {
    setSelectedSession({ id: session.id, release: session.release });
    const nextPath = `/monitor/overview/${session.id}`;
    if (location.pathname !== nextPath) {
      history.push(nextPath);
    }
  };

  return (
    <div className="border-t border-border overflow-hidden grow relative flex">
      <SplitPane direction="horizontal" gutterSize={6} className="flex-1">
        <SplitPane.Pane minSize={420} preferredSize="70%" className={"h-full"}>
            {/*<Flex id="analytics">
              <AnalyticCard title="Active sessions" value={27} data={[0, 3, 1, 5, 7]} />
              <AnalyticCard title="Errors" critical value={4} data={[0, 3, 3, 3, 5, 7]} />
            </Flex>*/}
            <SessionTable
              filter={filter}
              releaseFilterKey={MONITOR_SESSIONS_RELEASE_FILTER_KEY}
              showFailedState={showFailedState}
              onSessionClick={openSessionModal}
            />
            {modalSession ? (
              <SessionModal
                sessionId={modalSession.id}
                versionId={modalSession.version}
                releaseId={modalSession.release}
                open={true}
                onOpenChange={(open) => {
                  if (!open) {
                    setSelectedSession(null);
                    if (activeSessionId) {
                      history.push("/monitor/overview");
                    }
                  }
                }}
              />
            ) : null}
        </SplitPane.Pane>

          <SplitPane.CollapsiblePane persistId="monitor-overview-tasks" minSize={320} preferredSize="28rem" collapsedLabel="Tasks">
            <SplitPane.CollapsiblePane.Header className={"hidden"}>
            </SplitPane.CollapsiblePane.Header>
            <SplitPane.CollapsiblePane.Content>
              <RenderForRoles roles={["task-read-all", "task-read"]}>
              <div id="active-tasks" className="h-full p-4 gap-4 flex flex-col">
                <FlowTaskList />
              </div>
              </RenderForRoles>
            </SplitPane.CollapsiblePane.Content>
          </SplitPane.CollapsiblePane>
      </SplitPane>
    </div>
  );
};
